export const initialState = {
  isNewSpedNote: true,
  selectedStudents: [],
  singleSpedNote: false,
  isBulkSpedNote: false,
};
